module.exports = __webpack_public_path__ + "static/hero-89910070c1d9e4e314025d5707b3cb7c.mp4";